import { deletes, get, patch, post } from '@_shared/config';
import { IContentListResponse, TContentListOrder, TFolder, TFolderListOrder } from '../model';

export async function getContentListByFolder(folderId?: string, order?: TContentListOrder) {
	return get<IContentListResponse>(
		`/content?order=${order === undefined ? 'latest' : order}${folderId ? `&folder=${folderId}` : ''}`,
	);
}

export async function getFolderList(count: boolean, order: TFolderListOrder) {
	return get<TFolder[]>(`/content/folder?${count && 'count=true&'}order=${order}`);
}

export async function updateFolderName(folderId: string, name: string) {
	return patch(`/content/folder/${folderId}`, { name });
}

export async function createFolder(name: string) {
	return post(`/content/folder`, { name });
}

export async function deleteFolder(folderId: string) {
	return deletes(`/content/folder`, { folderId });
}

export async function updateFolderListOrder(folderIds: number[]) {
	return patch(`/content/folder/sort-order`, { folderIds });
}

export async function checkFolderListLimit() {
	return get<{ canCreate: boolean; canDelete: boolean }>(`/content/folder/limit`);
}
